<template>
  <div class="container my-3">
    <div class="row">
      <div class="col-sm-4">
        <div
          class="btn-group-vertical w-100 bg-white rounded"
          role="group"
          aria-label="Vertical button group"
        >
          <div
            class="btn btn-lg w-100 text-start flex-row d-flex justify-content-between"
            :class="{
              'btn-outline-dark btn-text': item.id != currentStepId,
              'btn-dark': item.id == currentStepId,
              'd-none': isAdmin === false
            }"
            v-for="item in faqData"
            :key="item.id"
            @click="setCurrentStepId(item.id)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>

      <div class="col-sm">
        <div class="game-title text-start gt-3 p-0 m-0">
          {{ currentStepContent.label }}
        </div>
        <div class="border-game mb-3"></div>
        <div class="card card-body text-start rounded-5">
          <HowToPlayFAQ v-if="currentStepId === 0" />
          <AchievementsFAQ v-if="currentStepId === 1" />
          <AdminFAQ v-if="currentStepId === 2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* https://vuejs.org/guide/essentials/lifecycle.html#lifecycle-diagram */
import { mapGetters } from "vuex";
import faqData from "@/data/faq.json";

import HowToPlayFAQ from "@/components/activity/faq/HowToPlayFAQ.vue";
import AchievementsFAQ from "@/components/activity/faq/AchievementsFAQ.vue";
import AdminFAQ from "@/components/activity/faq/AdminFAQ.vue";
export default {
  name: "FAQView",
  components: { HowToPlayFAQ, AchievementsFAQ, AdminFAQ },
  data() {
    return {
      faqData,
      stepId: 0,
      currentStepId: 0
    };
  },
  props: {},
  computed: {
    ...mapGetters(["isAdmin"]),
    limitStepId() {
      return this.faqData.length - 1;
    },
    currentStepContent() {
      return this.faqData.find((item) => item.id === this.currentStepId);
    }
  },
  methods: {
    setCurrentStepId(id) {
      this.currentStepId = id;
    }
  }
  /* lifecycle hooks */
};
</script>
